import React, { useRef, useState, useEffect } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

const LazyImage = ({ field, imageParams, ...props }) => {
  const ref = useRef();
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <span ref={ref} style={{ minHeight: 1 }}>
      {inView ? <Image field={field} imageParams={imageParams} {...props} /> : null}
    </span>
  );
};

export default LazyImage;